var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63605 11.293C3.44858 11.4805 3.34326 11.7348 3.34326 12C3.34326 12.2652 3.44858 12.5195 3.63605 12.707L9.29305 18.364C9.3853 18.4595 9.49564 18.5357 9.61764 18.5881C9.73965 18.6405 9.87087 18.6681 10.0036 18.6692C10.1364 18.6704 10.2681 18.6451 10.391 18.5948C10.5139 18.5445 10.6256 18.4703 10.7194 18.3764C10.8133 18.2825 10.8876 18.1708 10.9379 18.0479C10.9882 17.9251 11.0135 17.7934 11.0123 17.6606C11.0111 17.5278 10.9836 17.3966 10.9311 17.2746C10.8787 17.1526 10.8026 17.0422 10.707 16.95L6.75705 13L20 13C20.2653 13 20.5196 12.8946 20.7072 12.7071C20.8947 12.5196 21 12.2652 21 12C21 11.7348 20.8947 11.4804 20.7072 11.2929C20.5196 11.1053 20.2653 11 20 11L6.75705 11L10.707 7.04999C10.8892 6.86139 10.99 6.60879 10.9877 6.34659C10.9854 6.08439 10.8803 5.83358 10.6949 5.64817C10.5095 5.46276 10.2586 5.35759 9.99645 5.35532C9.73425 5.35304 9.48165 5.45383 9.29305 5.63599L3.63605 11.293Z",
    fill: "#004E77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.8469329af421c8d7db56e4acf4d22bb5.svg";
export { ForwardRef as ReactComponent };